/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceCaseArchiveCommand } from '../models/DeviceCaseArchiveCommand';
import type { GenerateImageUploadUrlCommand } from '../models/GenerateImageUploadUrlCommand';
import type { ListCaseResult } from '../models/ListCaseResult';
import type { ListTransitionReasonResult } from '../models/ListTransitionReasonResult';
import type { OpenCaseCommand } from '../models/OpenCaseCommand';
import type { UploadUrlResponse } from '../models/UploadUrlResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DeviceMarketplaceService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any OK
     * @throws ApiError
     */
    public archiveCase({
        entityType,
        entityId,
        requestBody,
    }: {
        entityType: 'SHOP' | 'FINANCIER',
        entityId: string,
        requestBody: DeviceCaseArchiveCommand,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/device-marketplace/client/{entityType}/{entityId}/cases/archive',
            path: {
                'entityType': entityType,
                'entityId': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns UploadUrlResponse OK
     * @throws ApiError
     */
    public generateImageUploadUrl({
        requestBody,
    }: {
        requestBody: GenerateImageUploadUrlCommand,
    }): CancelablePromise<UploadUrlResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/device-marketplace/client/images/upload-url',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ListCaseResult OK
     * @throws ApiError
     */
    public listPublicCases({
        page,
        size,
        sortOrder,
        sortBy,
        imeiOrSerial,
        os,
        createdAfter,
        createdBefore,
    }: {
        page: number,
        size: number,
        sortOrder: string,
        sortBy: string,
        imeiOrSerial?: string,
        os?: 'IOS' | 'ANDROID',
        createdAfter?: string,
        createdBefore?: string,
    }): CancelablePromise<ListCaseResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/device-marketplace/client/cases',
            query: {
                'imeiOrSerial': imeiOrSerial,
                'os': os,
                'createdAfter': createdAfter,
                'createdBefore': createdBefore,
                'page': page,
                'size': size,
                'sortOrder': sortOrder,
                'sortBy': sortBy,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public openCase({
        requestBody,
    }: {
        requestBody: OpenCaseCommand,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/device-marketplace/client/cases',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ListCaseResult OK
     * @throws ApiError
     */
    public listEntityCases({
        entityType,
        entityId,
        page,
        size,
        sortOrder,
        sortBy,
        imeiOrSerial,
        os,
        status,
        createdAfter,
        createdBefore,
    }: {
        entityType: 'SHOP' | 'FINANCIER',
        entityId: string,
        page: number,
        size: number,
        sortOrder: string,
        sortBy: string,
        imeiOrSerial?: string,
        os?: 'IOS' | 'ANDROID',
        status?: 'PENDING' | 'APPROVED' | 'ARCHIVED' | 'REJECTED' | 'CLOSED',
        createdAfter?: string,
        createdBefore?: string,
    }): CancelablePromise<ListCaseResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/device-marketplace/client/{entityType}/{entityId}/cases',
            path: {
                'entityType': entityType,
                'entityId': entityId,
            },
            query: {
                'imeiOrSerial': imeiOrSerial,
                'os': os,
                'status': status,
                'createdAfter': createdAfter,
                'createdBefore': createdBefore,
                'page': page,
                'size': size,
                'sortOrder': sortOrder,
                'sortBy': sortBy,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ListTransitionReasonResult OK
     * @throws ApiError
     */
    public listReasons({
        entityType,
        entityId,
        caseId,
    }: {
        entityType: 'SHOP' | 'FINANCIER',
        entityId: string,
        caseId: string,
    }): CancelablePromise<ListTransitionReasonResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/device-marketplace/client/{entityType}/{entityId}/cases/reasons',
            path: {
                'entityType': entityType,
                'entityId': entityId,
            },
            query: {
                'caseId': caseId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
